import ufeApi from 'services/api/ufeApi';

// https://jira.sephora.com/browse/CE-286

function submitEmailSMSOptInForm(payloadData) {
    const url = '/gway/v2/util/OptinEmailSms';
    const payload = {
        locale: payloadData.locale,
        phoneNumber: payloadData.phoneNumber,
        type: payloadData.type
    };
    const { enableSMSOptInParameters = false } = Sephora.configurationSettings;

    if (enableSMSOptInParameters) {
        payload.pageName = payloadData.pageName;
        payload.pageType = payloadData.pageType;
    }

    if (payloadData.requestOrigin) {
        payload.requestOrigin = payloadData.requestOrigin;
    }

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(payload)
        })
        .then(data => (data.errorCode || data.errors ? Promise.reject(data) : data));
}

export default { submitEmailSMSOptInForm };
